export const contacts = [
  {
    email: "schoolsub@scmp.com",
    name: "School Subscription",
  },
  {
    email: "postiesevent@scmp.com",
    name: "Edutainment Camp and Event",
  },
];
